import { Outlet } from 'react-router'

const SettingLayout = () => {
  return (
    <Outlet />
  )
}

export default SettingLayout